import { PackageType } from "../types";

const VALID_PACKAGE_TYPES = Object.values(PackageType) as string[];

/**
 * Converts a string to a PackageType (mainly used for url params)
 *
 * @param value - The string to convert to a PackageType
 * @returns PackageType
 */
export const toPackageType = (value: string | null): PackageType => {
  if (value == null) return PackageType.HOTEL_FLIGHT_CAR;
  return VALID_PACKAGE_TYPES.includes(value)
    ? (value as PackageType)
    : PackageType.HOTEL_FLIGHT_CAR;
};
